import { FecImportAnalysisErrorCode } from '../enums/fecImportAnalysisErrorCode'
import type { FecImportItem } from '../query-api'
import { getFecImportAnalysisErrorCode } from './getFecImportAnalysisErrorCode'

const DEFAULT_MISSING_COLUMNS = 'JournalCode, EcritureDate, Montant'

const ANALYSIS_ERROR_TITLE_KEYS: Record<FecImportAnalysisErrorCode, string> = {
  [FecImportAnalysisErrorCode.DetectionFailed]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.detection_failed_title',
  [FecImportAnalysisErrorCode.InvalidEncoding]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.invalid_encoding_title',
  [FecImportAnalysisErrorCode.MissingColumns]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.missing_columns_title',
  [FecImportAnalysisErrorCode.ParsingFailed]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.parsing_failed_title',
  [FecImportAnalysisErrorCode.Timeout]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.timeout_title',
}

const ANALYSIS_ERROR_MESSAGE_KEYS: Record<FecImportAnalysisErrorCode, string> = {
  [FecImportAnalysisErrorCode.DetectionFailed]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.detection_failed_message',
  [FecImportAnalysisErrorCode.InvalidEncoding]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.invalid_encoding_message',
  [FecImportAnalysisErrorCode.MissingColumns]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.missing_columns_message',
  [FecImportAnalysisErrorCode.ParsingFailed]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.parsing_failed_message',
  [FecImportAnalysisErrorCode.Timeout]:
    'settings.organization.accounting.fec_file_import.modal.confirmation_step.timeout_message',
}

const getMissingColumnsLabel = (fecImport: FecImportItem): string => {
  const columnsFromErrors =
    fecImport.errors?.map((error) => error.column?.trim()).filter((column): column is string => !!column) ?? []

  return columnsFromErrors.join(', ') || DEFAULT_MISSING_COLUMNS
}

export const getFecImportAnalysisErrorTranslation = (fecImport: FecImportItem) => {
  const errorCode = getFecImportAnalysisErrorCode(fecImport)
  const columns = getMissingColumnsLabel(fecImport)

  return {
    errorCode,
    interpolation: { columns },
    messageKey: ANALYSIS_ERROR_MESSAGE_KEYS[errorCode],
    titleKey: ANALYSIS_ERROR_TITLE_KEYS[errorCode],
  }
}
